import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

const EquipamentoListar = React.lazy(
  () => import('@/features/equipamentos/pages/equipamento-listar'),
)
const EquipamentoCriar = React.lazy(
  () => import('@/features/equipamentos/pages/equipamento-criar'),
)
const EquipamentoEditar = React.lazy(
  () => import('@/features/equipamentos/pages/equipamento-editar'),
)
const EquipamentoPainel = React.lazy(
  () => import('@/features/equipamentos/pages/equipamento-painel'),
)
const VistaCriar = React.lazy(
  () => import('@/features/equipamentos/features/vista/pages/criar'),
)
const VistaPainel = React.lazy(
  () => import('@/features/equipamentos/features/vista/pages/painel'),
)
const VistaEditar = React.lazy(
  () => import('@/features/equipamentos/features/vista/pages/editar'),
)
const VistaItemEditar = React.lazy(
  () => import('@/features/equipamentos/features/vista/pages/item-editar'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<EquipamentoListar />} />
      <Route path="novo" element={<EquipamentoCriar />} />
      <Route path=":equipment_id" element={<Outlet />}>
        <Route index element={<EquipamentoPainel />} />
        <Route path="editar" element={<EquipamentoEditar />} />
        <Route path="vistas" element={<Outlet />}>
          <Route path="novo" element={<VistaCriar />} />
          <Route path=":vista_id" element={<Outlet />}>
            <Route index element={<VistaPainel />} />
            <Route path="editar" element={<VistaEditar />} />
            <Route path="itens/editar" element={<VistaItemEditar />} />
          </Route>
          <Route />
        </Route>
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
